import { Helmet } from "react-helmet";

const DEFAULT_TITLE = "GKC Klinica - Medical and Healthcare";
const DEFAULT_DESCRIPTION =
  "GKC Klinica provides trusted healthcare services, consultations, and medical support.";
const DEFAULT_IMAGE = "https://gkcklinica.com/images/ogImage.png";
const DEFAULT_KEYWORDS =
  "doctor, healthcare, clinic, hospital, medical services, online consultation";
const SITE_NAME = "GKC Klinica";

const Seo = ({
  title,
  description,
  image,
  url,
  keywords,
}) => {
  const fullTitle = title
    ? `${title} - ${SITE_NAME}`
    : DEFAULT_TITLE;

  return (
    <Helmet>

      <title>{fullTitle}</title>

 
      <meta
        name="description"
        content={description || DEFAULT_DESCRIPTION}
      />
      <meta
        name="keywords"
        content={keywords || DEFAULT_KEYWORDS}
      />

      <meta property="og:title" content={fullTitle} />
      <meta
        property="og:description"
        content={description || DEFAULT_DESCRIPTION}
      />
      <meta property="og:image" content={image || DEFAULT_IMAGE} />
      <meta property="og:url" content={url || window.location.href} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta
        name="twitter:description"
        content={description || DEFAULT_DESCRIPTION}
      />
      <meta name="twitter:image" content={image || DEFAULT_IMAGE} />
    </Helmet>
  );
};

export default Seo;